import declineNotifications from './declineNotifications';
import requestPermission from './requestPermission';
import saveOptIn from './saveOptIn';

const handleNotificationPermission = (): Promise<NotificationPermission> =>
  requestPermission().then(async (permission: NotificationPermission) => {
    if (permission === 'granted') {
      // Reset permission decline flag and saveOptIn to notifications
      await declineNotifications(false);
      await saveOptIn();
    }

    return permission;
  });

export default handleNotificationPermission;
